module.exports = __webpack_public_path__ + "img/meditation_1--active.7172e4c1.svg";